import React, { useCallback, useState } from 'react';
import { JoyAssistantIcon } from './JoyAssistantIcon';
import { HowItWorksCarousel } from './HowItWorksCarousel';
import { ScreenLightbox } from './ScreenLightbox';
import { howItWorksSteps } from '../data/howItWorksSteps';
export const HowItWorks: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [trigger, setTrigger] = useState<HTMLElement | null>(null);
  const activeStep = activeIndex !== null ? howItWorksSteps[activeIndex] : null;
  const closeLightbox = useCallback(() => setActiveIndex(null), []);
  const openLightbox = useCallback((index: number, button: HTMLButtonElement) => {
    setTrigger(button);
    setActiveIndex(index);
  }, []);
  return <section id="how-it-works" aria-labelledby="how-heading" className="section-y bg-cloud" data-id="element-87" data-mp="gs0drqnh9y8e">
      <div className="section-container" data-id="element-88" data-mp="14humbw0rl0mu">
        <div className="max-w-3xl" data-id="element-89" data-mp="19ae3f2ynudwe">
          <h2 id="how-heading" className="section-heading" data-id="element-90" data-mp="19bfeh7fof0e4">
            A clearer path into care.
          </h2>
          <p className="section-lead mt-4 max-w-[44rem]" data-id="element-91" data-mp="2rlxo91laqw43">
            We’re building online, therapist-led groups where the people,
            therapeutic approach, and goals are thoughtfully matched. From
            finding your fit to working toward meaningful change, here’s how
            care will come together.
          </p>
        </div>

        <HowItWorksCarousel steps={howItWorksSteps} onEnlarge={openLightbox} data-id="element-92" data-mp="3abmfajm11se6" />

        <p className="mt-6 text-sm leading-relaxed text-plum-gray" data-id="element-93" data-mp="36akevzgdjaam">
          Screens from our client prototype. Illustrative content; the
          experience is in development.
        </p>

        <div className="mt-8 flex items-center gap-4 rounded-2xl bg-white p-6 shadow-card md:mt-10" data-id="element-94" data-mp="3k7z6nau3nu5r">
          <JoyAssistantIcon className="flex-shrink-0 rounded-full" data-id="element-95" data-mp="1pwarp8nvbrld" />
          <p className="leading-relaxed text-ink-text" data-id="element-96" data-mp="1pwkj90oka6t6">
            <span className="font-medium text-deep-juniper" data-id="element-97" data-mp="1ky0uytmhwixn">Joy</span> is
            Re:Joy’s AI assistant, designed to support intake and coordination.
            Your therapist leads your care.
          </p>
        </div>
      </div>

      <ScreenLightbox screen={activeStep ? activeStep.screen : null} title={activeStep ? activeStep.title : ''} returnFocusTo={trigger} onClose={closeLightbox} data-id="element-98" data-mp="3pz3ig9opwcgr" />
    </section>;
};